import { render, staticRenderFns } from "./componentRelation.vue?vue&type=template&id=7a00b20a&"
import script from "./componentRelation.vue?vue&type=script&lang=ts&"
export * from "./componentRelation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports